const cookiesWhitelist = [
  'utm_source',
  'utm_medium',
  'utm_content',
  'utm_campaign',
  'utm_term',
  'utm_keyword',
  'PN_Page_Before_Sign_Up',
  'PN_First_Page_Visited',
];

export default cookiesWhitelist;



// WEBPACK FOOTER //
// ./src/cookiesWhitelist.js